<script setup>
  const props = defineProps({
      code: String,
      name: String,
      email: String,
      phone: String,
      dui: String,
      notes: String
  })
</script>
<template>
  <div class="row">
    <div class="col-lg-8 col-md-7">
      <card>
        <div slot="header">
          <h4 class="title">Detalle de autor</h4>
        </div>
        <div>
          <form>
            <div class="row">
              <div class="col-md-6">
                <input type="hidden" v-model="author.code" />
                <fg-input type="text" label="Nombre" placeholder="Nombre" v-model="author.name">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input type="text" label="Correo" placeholder="Correo" v-model="author.email">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input type="text" label="Teléfono" placeholder="Teléfono" v-model="author.phone">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input type="text" label="DUI" placeholder="DUI" v-model="author.dui">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <fg-input label="Notas">
                  <textarea class="form-control" placeholder="Notas" rows="4" v-model="author.notes"></textarea>
                </fg-input>
              </div>
            </div>

            <div>
              <button
                type="submit"
                class="btn btn-primary btn-fill btn-wd"
                @click.prevent="saveRecord"
              >
                Guardar autor
              </button>
              <router-link
                to="/books/authors"
                custom
                v-slot="{ navigate }"
              >
                <button
                  type="button"
                  class="btn btn-default btn-fill btn-wd pull-right"
                  @click="navigate"
                  role="link"
                >
                  Cancelar
                </button>
              </router-link>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Input, Tag, Select, Option } from 'element-ui'
import Swal from 'sweetalert2'
import axios from "axios";

export default {
  components: {
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      author: {
        code: this.code,
        name: this.name,
        email: this.email,
        phone: this.phone,
        dui: this.dui,
        notes: this.notes
      }
    };
  },
  methods: {
    saveRecord() {
      if (this.author.code !== 0) {
        this.updateBook(this.author);
      } else {
        this.createBook(this.author);
      }
    },
    createBook (row) {
      axios.post(this.$systemVariables.apiUrl + 'authors', row, {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        Swal.fire({
          title: this.$systemVariables.recordCreatedSuccessfully,
          html: "",
          icon: "success"
        })
        .then(function () {
          window.location.href = '#/books/authors';
        });
      })
      .catch((error) => {
        //console.error('Error al crear el libro:', error);
      });
    },
    updateBook (row) {
      axios.put(this.$systemVariables.apiUrl + 'authors/' + row.code, row, {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        Swal.fire({
          title: this.$systemVariables.recordUpdatedSuccessfully,
          html: "",
          icon: "success"
        })
        .then(function () {
          window.location.href = '#/books/authors';
        });
      })
      .catch((error) => {
        //console.error('Error al guardar el libro:', error);
      });
    }
  },
};
</script>
<style>
  .el-input__inner {
    cursor: pointer !important;
  }
</style>
